<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tqegGY/images/still-life-final-cover---tana-jenkins.jpg?1696786074501" alt="This image is the cover for the book Love at First Bite"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love at First Bite
      </h1>
      <p class="bookDescription body article font2">
        <p>This cookbook, created by <i>New York Times, USA TODAY<i></i> and National Bestselling Authors, is inspired by a collective effort from the #ILIKEFREEBOOKS promotion. It contains an interesting mix of cuisines from all over the world as well as excerpts of the books and life experiences that inspired the recipe and the author. Also, feel free to click on the books that are offered, it will take you straight to the download pages. Enjoy!</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naleighna Kai, La Ammitai, Stephanie M. Freeman, S. L. Jennings, J. L. Campbell, Martha Kennerson, Laverne Thompson, MarZe Scott, Janice M. Allen, Shakir Rashaan, Auriella Skye, J. L. Woodson, Elizabeth Schechter, Nina Potter, J. E. Pace, Butterfly Brooks, Sharon Michalove, Katie Vincent, Tana Jenkins, Linda Shantz, CA Miconi, Tina Glasneck
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macro Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eab0fe32